import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import {connect} from "react-redux";
import {useMemo, useState} from "react";
import {useNavigate} from "react-router-dom";
import {evaluatePassword} from "../services/passwordPolicy";

const mapStateToProps = ({dispatch, user}) => ({
    dispatch: dispatch,
    user: user
});

// Shown instead of the application whenever the signed-in user still owes a
// password change. There is deliberately no skip and no dismiss: signing out is
// the only way past it. This is convenience only - the real gate is
// AuthorizeAttribute, which refuses the token on every route but this one.
const ChangePassword = (props) => {
    const navigate = useNavigate();
    const {dispatch, user} = props;

    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const {rules, allPassed} = useMemo(
        () => evaluatePassword(newPassword, user.username),
        [newPassword, user.username]
    );

    const confirmMatches = newPassword.length > 0 && newPassword === confirmPassword;
    const differsFromCurrent = newPassword.length > 0 && newPassword !== currentPassword;
    const canSubmit = allPassed && confirmMatches && differsFromCurrent
        && currentPassword.length > 0 && !user.loading;

    const onSubmit = event => {
        event.preventDefault();
        event.stopPropagation();
        if (!canSubmit) return;
        dispatch({
            type: 'user/CHANGE_PASSWORD',
            payload: {currentPassword, newPassword, navigate},
        });
    };

    const onSignOut = () => dispatch({type: 'user/LOGOUT'});

    const RuleItem = ({passed, label}) => (
        <li className={passed ? "text-success" : "text-muted"}>
            <span className="me-2 fw-bold">{passed ? "✓" : "○"}</span>{label}
        </li>
    );

    return (
        <div className="row mx-0 onboard-wrapper"
             style={{
                 background: "url('./pexels-photo-534174 1.jpeg') no-repeat center center / cover",
                 minHeight: '100vh'
             }}>
            <div className="col-md-7 col-lg-8 px-md-0 d-none d-md-flex"/>
            <div className="col-md-5 col-lg-4 px-3 px-xl-0 align-self-center">
                <div className="card shadow-sm p-4 border-0 login-form m-auto ms-md-0">
                    <h2 className="text-center fs-2 fw-bold my-3">Set a New Password</h2>
                    <p className="text-muted text-center">
                        Your password must be updated before you can continue.
                    </p>

                    {user.passwordChangeError &&
                        <div className="alert alert-danger py-2"
                             dangerouslySetInnerHTML={{__html: user.passwordChangeError}}/>}

                    <Form onSubmit={onSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-medium fs-5">Current Password</Form.Label>
                            <Form.Control required type="password" placeholder="Current password"
                                          className="form-field" value={currentPassword}
                                          onChange={e => setCurrentPassword(e.target.value)}/>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="fw-medium fs-5">New Password</Form.Label>
                            <Form.Control required type="password" placeholder="New password"
                                          className="form-field" value={newPassword}
                                          onChange={e => setNewPassword(e.target.value)}/>
                        </Form.Group>

                        <ul className="list-unstyled small mb-3">
                            {rules.map(r => <RuleItem key={r.key} passed={r.passed} label={r.label}/>)}
                            <RuleItem passed={differsFromCurrent}
                                      label="Different from your current password"/>
                        </ul>

                        <Form.Group className="mb-3">
                            <Form.Label className="fw-medium fs-5">Confirm New Password</Form.Label>
                            <Form.Control required type="password" placeholder="Confirm new password"
                                          className="form-field" value={confirmPassword}
                                          onChange={e => setConfirmPassword(e.target.value)}/>
                            {confirmPassword.length > 0 && !confirmMatches &&
                                <Form.Text className="text-danger">
                                    The two passwords do not match.
                                </Form.Text>}
                        </Form.Group>

                        <Button type="submit" variant="primary" size="lg" disabled={!canSubmit}
                                className="w-100 fs-5 fw-medium">
                            {user.loading ? "Saving" : "Change Password"}
                        </Button>
                    </Form>

                    <div className="text-center mt-3">
                        <Button variant="link" className="text-decoration-none" onClick={onSignOut}>
                            Sign out
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default connect(mapStateToProps)(ChangePassword);
